import { ModuleWithProviders, NgModule, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { select, Store, StoreModule } from '@ngrx/store';
import * as fromDrupalData from './+state/drupal-data.reducer';
import { EffectsModule } from '@ngrx/effects';
import { DrupalDataEffects } from './+state/drupal-data.effects';
import { TranslocoService } from '@ngneat/transloco';
import { State } from './+state/drupal-data.reducer';
import {
  selectAllDrupalData,
  selectAllMedia,
  selectAllNodes,
  selectAllTerms,
} from './+state/drupal-data.selectors';
import {
  GetEntitiesPipe,
  GetEntityPipe,
  GetRequestPipe,
} from './+state/get-data-item.pipe';
import {
  ALL_DRUPAL_DATA,
  ALL_DRUPAL_MEDIA,
  ALL_DRUPAL_NODES,
  ALL_DRUPAL_TERMS,
  AVAILABLE_LANGUAGES,
  CURRENT_LANGUAGE,
  MODEL_CLASS_MAP,
} from '@nx-icilalune/data/access/tokens';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    StoreModule.forFeature(
      fromDrupalData.drupalDatasFeatureKey,
      fromDrupalData.reducer
    ),
    EffectsModule.forFeature([DrupalDataEffects]),
  ],
  providers: [
    GetEntityPipe,
    GetEntitiesPipe,
    GetRequestPipe,
    {
      provide: AVAILABLE_LANGUAGES,
      deps: [TranslocoService],
      useFactory: (translocoService: TranslocoService) => {
        return translocoService.getAvailableLangs();
      },
    },
    {
      provide: CURRENT_LANGUAGE,
      deps: [TranslocoService],
      useFactory: (translocoService: TranslocoService) => {
        return translocoService.langChanges$;
      },
    },
    {
      provide: ALL_DRUPAL_DATA,
      deps: [Store],
      useFactory: (store: Store<State>) => {
        return store.pipe(select(selectAllDrupalData));
      },
    },
    {
      provide: ALL_DRUPAL_NODES,
      deps: [Store],
      useFactory: (store: Store<State>) => {
        return store.pipe(select(selectAllNodes));
      },
    },
    {
      provide: ALL_DRUPAL_TERMS,
      deps: [Store],
      useFactory: (store: Store<State>) => {
        return store.pipe(select(selectAllTerms));
      },
    },
    {
      provide: ALL_DRUPAL_MEDIA,
      deps: [Store],
      useFactory: (store: Store<State>) => {
        return store.pipe(select(selectAllMedia));
      },
    },
  ],
})
export class DataAccessModule {
  static forRoot(
    modelClassMap: Map<string, Type<any>>
  ): ModuleWithProviders<DataAccessModule> {
    return {
      ngModule: DataAccessModule,
      providers: [
        {
          provide: MODEL_CLASS_MAP,
          useFactory: () => {
            return modelClassMap;
          },
        },
      ],
    };
  }
}
